export const UPDATE_NEARBY_ADS = 'UPDATE_NEARBY_ADS';

type NearbyAds = {
    ads: any[];
    totalNearbyAdsNumFound: number;
};

export const updateNearbyAds = (payload: NearbyAds) => ({
    type: UPDATE_NEARBY_ADS,
    payload,
});

export default (
    state: NearbyAds = { ads: [], totalNearbyAdsNumFound: 0 },
    action: { type: string; payload: NearbyAds }
) => (action.type === UPDATE_NEARBY_ADS ? action.payload || [] : state);
